
import { mapGetters } from 'vuex'
import NgtorchRunChip from '@/components/NgtorchRunChip.vue'
import { ngtorchRunsVisible, createdMillis, reportRunOverride, buildOverride } from '@/utils/ngtorchRuns.js'

// Which ngtorch produced the model on screen: the run that built it (EKRM and automatic models) and the
// run that generated the report shown now, which a later recalculation may have run on another commit.
export default {
  components: {
    NgtorchRunChip
  },
  props: {
    model: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      build: null,
      report: null,
      // An automatic model whose report was never recalculated shows the one its build produced.
      reportFromBuild: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'authUser'
    ]),
    visible () {
      return ngtorchRunsVisible(this.authUser)
    },
    // A recalculated report is a new run to read.
    loadKey () {
      if (!this.visible || !this.model || !this.model.id) return ''
      return `${this.model.id}/${createdMillis(this.model.model_report_updated_at)}`
    }
  },
  watch: {
    loadKey: {
      handler () {
        this.load()
      },
      immediate: true
    }
  },
  methods: {
    async load () {
      const key = this.loadKey
      if (!key) {
        this.build = null
        this.report = null
        this.reportFromBuild = false
        return
      }
      const model = this.model
      const [build, report] = await Promise.all([
        buildOverride(model).catch(error => {
          console.error(`Could not read the ngtorch build of model ${model.id}`, error)
          return null
        }),
        reportRunOverride(model).catch(error => {
          console.error(`Could not read the ngtorch report run of model ${model.id}`, error)
          return null
        })
      ])
      // The model changed while this was loading, and the newer load owns the result.
      if (key !== this.loadKey) return
      this.build = build
      this.report = report || null
      this.reportFromBuild = report === undefined && Boolean(model.automatic_creation)
    }
  }
}
